import { render } from "./CaseCenterView.vue?vue&type=template&id=426b0991&scoped=true"
import script from "./CaseCenterView.vue?vue&type=script&lang=js"
export * from "./CaseCenterView.vue?vue&type=script&lang=js"

import "./CaseCenterView.vue?vue&type=style&index=0&id=426b0991&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-426b0991"]])

export default __exports__